require('../position/position.css');
module.exports = require('./index-nocss.js');
